import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class CustomVariantDateElement extends HTMLElement {
  connectedCallback() {
    const sectionRoot = this.closest('.shopify-section, dialog');
    sectionRoot?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantChange);
  }

  disconnectedCallback() {
    const sectionRoot = this.closest('.shopify-section, dialog');
    sectionRoot?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantChange);
  }

  #handleVariantChange = (event) => {
    const { data } = event.detail;
    const target = event.target;

    if (!data.newProduct && target instanceof HTMLElement && target.dataset.productId !== this.dataset.productId) {
      return;
    }
    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    }

    const incoming = data.html.querySelector('custom-variant-date');
    if (!incoming) return;

    morph(this, incoming, { childrenOnly: true });
  };
}

if (!customElements.get('custom-variant-date')) {
  customElements.define('custom-variant-date', CustomVariantDateElement);
}